import styled from 'styled-components/macro';
import { defaultStyle } from '../../styles/GlobalTheme/GlobalStyles';
import px2vw from '../../utils/px2vw';


export const Card = styled.div`
    width: ${px2vw(480)};
    height: ${px2vw(312)};
    background: #FFFFFF;
    box-shadow: 0px 20px 40px 10px rgba(0, 0, 0, 0.1);
    border-radius: ${px2vw(20)};
    display: flex;
    flex-direction: ${props => {
        return props.aligSvgTopOrBottom === 'Bottom' ? 'column-reverse' : 'column'
    }};
    justify-content: space-evenly;     
    margin-top: ${px2vw(40)}; 
    margin-bottom: ${px2vw(40)};
     
    background: white;
    transition: background-size .3s ease-out;
    :hover { 
        background-size: 100%;
        background: ${props => props.animationDirection}; 
        div {
            color: white;
            transition: color 0.2s ease-out;
        }
    }
    @media only screen and (max-width: 425px) {     
        width: 100%;
        height: ${px2vw(824)};    
        margin-top: ${px2vw(20)}; 
        margin-bottom: ${px2vw(20)};  
        box-shadow: 0px 10px 20px 7px rgba(0, 0, 0, 0.1); 
        border-radius: ${px2vw(40)};        
    }
`;


export const SvgContent = styled.div`
   align-self: ${props => {
        return props.aligSvgLeftorRight === 'Right' ? 'flex-end' : 'flex-start'
    }};
    margin-left: ${px2vw(56)};
    margin-right: ${px2vw(56)};

    @media only screen and (max-width: 425px) {     
        margin-right: 10%;
        margin-left: 10%;
    }
`;

export const TextContent = styled.div`
    width: ${px2vw(300)};
    height: ${px2vw(108)};    
    font-family: ${props => props.theme.fontFamily};
    font-size: ${props => props.theme.cardFontSize};
    line-height: ${px2vw(36)};
    color: #0A2540;
    margin-left: ${px2vw(56)};
    margin-right: ${px2vw(56)};
    @media only screen and (max-width: 425px) {     
        width: 80%;
        height: ${px2vw(300)};   
        line-height: 2;
        letter-spacing: 1.5px; 
        margin-right: 10%;
        margin-left: 10%;
        padding-bottom: 7%;
    }
`;